import { reduce } from "et3-type-guards";
import { memoize } from "lodash";
import { computed, observable } from "mobx";

import { apiCallGetWorkloadData } from "../../../api/auditor-api/api-call-get-workload-data";
import { getSpecificDateWithDays } from "../../../core/et3-date";
import { getDaysDifference } from "../../../helpers/et3-date-helper";
import { TWorkloadData } from "../../../Types";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";

class WorkloadStore {
  workloadData = observable.box<
    {
      event_name: string;
      incoming: number;
      outgoingByCSRTotal: number;
      outgoingByAI: number;
      difference: number;
    }[]
  >([]);

  workloadDataByCSR = observable.box<
    {
      adminName: string;
      descriptionCount: number;
      descriptionPercentage: string;
      peerDescriptionCount: number;
      peerDescriptionPercentage: string;
      pictureCount: number;
      picturePercentage: string;
      reportCount: number;
      reportPercentage: string;
      investigationCount: number;
      investigationPercentage: string;
    }[]
  >([]);

  workloadDataTotalByCsr = computed(() => {});
  dateMinInput = observable.box<Date>(
    getSpecificDateWithDays({ daysSubtracted: 1, daysAdded: 0 })
  );
  dateMaxInput = observable.box<Date>(
    getSpecificDateWithDays({ daysSubtracted: 0, daysAdded: 1 })
  );
  getWorkloadData = async () => {
    this.workloadData.set([]);
    this.workloadDataByCSR.set([]);
    const daysDiff = getDaysDifference({
      dateFrom: this.dateMinInput.get(),
      dateTo: this.dateMaxInput.get()
    });
    if (daysDiff < 0) {
      getCorePopUpStore().showAlertMessage("SELECT_CORRECT_DATE_RANGE");
      return;
    }
    getCoreUIStore().setIsLoading("AUDITOR_WORKLOAD_DATA", true);

    const { data, code, status } = await apiCallGetWorkloadData({
      dateMin: this.dateMinInput.get(),
      dateMax: this.dateMaxInput.get()
    });

    if (status === "OK") {
      const workload = reduce(() => data.workload, []);
      const workloadDataByCSR = reduce(() => data.totalWorkLoadByCSRs, []);
      this.workloadDataByCSR.set(workloadDataByCSR);
      workload.forEach((dataRow) => {
        const getDataRow: TWorkloadData = dataRow;
        const incoming = reduce(() => getDataRow.incoming, 0);
        const outgoingByCSRTotal = reduce(
          () => getDataRow.outgoingByCSRTotal,
          0
        );
        const outgoingByAI = reduce(() => getDataRow.outgoingByAI, 0);

        const type = reduce(() => getDataRow.type, "");

        const difference = incoming - outgoingByCSRTotal - outgoingByAI;

        const workloadData = this.workloadData.get();

        workloadData.push({
          event_name: type,
          incoming,
          outgoingByCSRTotal,
          outgoingByAI,
          difference
        });
      });
    }
    getCoreUIStore().setIsLoading("AUDITOR_WORKLOAD_DATA", false);
    if (status === "ERROR") {
      getCorePopUpStore().showAlertMessage(code);
    }
  };

  getWorkloadArraysData = () => {
    return {
      workloadDataArray: getWorkloadStore().workloadData.get(),
      workloadDataByCSRArray: getWorkloadStore().workloadDataByCSR.get()
    };
  };
}

export const getWorkloadStore = memoize(
  () => new WorkloadStore(),
  () => 1
);
export default getWorkloadStore;
